import { COLORS } from '@btime/constants'
import { fromNow } from '@btime/helpers'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { SmallText } from '../../../components/presentation/Text'
import { formatRunningTime } from '../../../utils/helpers/date'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import EntityPresenter from '../_shared/EntityPresenter'
import LabelValue from '../../../components/presentation/LabelValue'
import LevelTag from '../_shared/LevelTag'
import LogTags from '../_shared/LogTags'
import OriginTag from '../_shared/OriginTag'
import Separator from '../../../components/helpers/Separator'
import UserPresenter from '../../../containers/users/UserPresenter'
import Button from '../../../packages/kiti/components/actions/Button'
import { useSaveServiceOrder } from '../_request/saveServiceOrder'

const SideData = props => {
  const { data: log } = useCurrentModal()
  const [saveServiceOrder, state] = useSaveServiceOrder()
  const shouldShowRecoverbutton = log.name === 'saveServiceOrderReplies' && log.origin === 'mobile'

  return (
    <>
      {shouldShowRecoverbutton && (
        <Button loading={state.loading} onClick={saveServiceOrder}>
          {'Reenviar respostas e concluir atividade'}
        </Button>
      )}
      <Separator weight={2} />
      <SmallText bold>Informações gerais</SmallText>
      <Separator weight={2} />
      <LabelValue label="Origem" children={<OriginTag origin={log.origin} />} />
      <Separator weight={2} />
      <LabelValue label="Level" children={<LevelTag level={log.level} />} />

      <Separator weight={2} />
      <HorizontalLine thin lineColor={COLORS.light2} />

      <Separator weight={2} />
      <LabelValue label="Entidade afetada" children={<EntityPresenter entity={log.entity} entities={log.entities} />} />
      <Separator weight={2} />
      <LabelValue label="Usuário" children={<UserPresenter user={log.user} />} />

      <Separator weight={2} />
      <HorizontalLine thin lineColor={COLORS.light2} />

      <Separator weight={2} />
      <LabelValue label="Data de inserção" value={fromNow(log.insertedAt)} />
      <Separator weight={2} />
      <LabelValue label="Data no dispositivo" value={fromNow(log.happenedAt)} />
      <Separator weight={2} />
      <LabelValue label="Tempo de execução" value={formatRunningTime(log.executionTime)} />

      <Separator weight={2} />
      <HorizontalLine thin lineColor={COLORS.light2} />

      <Separator weight={2} />
      <LabelValue label="ID da requisição" value={log.requestId} />
      <Separator weight={2} />
      <LabelValue label="Tags" children={log.tags && <LogTags tags={log.tags} />} />
    </>
  )
}

export default SideData
